import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import {
  mediaHelper,
  Li,
  P,
  paletteHelper,
  spacingHelper,
  typographyHelper,
  Ul,
  Text,
} from '@property.com.au/ui-kit';
import { ContentBrick } from '../../../../app-kit/components/ContentBrick/ContentBrick';
import { DynamicContent } from '../../../../app-kit/components/DynamicContent/DynamicContent';
import {
  DynamicContents,
  DynamicContentsItem,
} from '../../../../app-kit/components/DynamicContent/types';

const StyledP = styled(P)`
  ${typographyHelper('body01Bold')}
`;

const StyledContentBrick = styled(ContentBrick)`
  margin-bottom: ${spacingHelper('extraSmall')};
`;

const OverlayItem = styled(Li)`
  overflow-wrap: break-word;
  flex-basis: 100%;
  ${mediaHelper('tabletMin')} {
    flex-basis: 50%;
    :only-of-type {
      flex-basis: 100%;
    }
  }
  ${typographyHelper('body02')}
  color: ${paletteHelper('textSecondary')};
  padding-right: ${spacingHelper('threeExtraLarge')};
  padding-left: ${spacingHelper('twoExtraSmall')};
`;

const OverlaySummary = styled.div`
  width: 20rem;
`;

const OverlaySummaries = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacingHelper('twoExtraSmall')} 5.5rem;
`;

const OverlayList = styled(Ul)`
  margin-top: ${spacingHelper('twoExtraSmall')};
  padding-left: calc(${spacingHelper('medium')} + ${spacingHelper('twoExtraSmall')});
  padding-bottom: ${spacingHelper('large')};
`;

const OverlayTypeTitle = styled(Text)`
  ${typographyHelper('subtitle02')};
  color: ${paletteHelper('textPrimary')};
`;

export const MoreInformation = styled(DynamicContent)`
  ${typographyHelper('body02')}
`;

interface OverlaySummaryBrickProps {
  title: string;
  overlayTypeSummaries: { overlayType: string; overlays: string[] }[];
  moreInformation: DynamicContents<DynamicContentsItem>;
}

export const OverlaySummaryBrick: FunctionComponent<OverlaySummaryBrickProps> = ({
  title,
  overlayTypeSummaries,
  moreInformation,
}) => {
  return (
    <StyledContentBrick
      title={title}
      titleComponent={<StyledP variant="subtitle01">{title}</StyledP>}
    >
      <OverlaySummaries>
        {overlayTypeSummaries.map(({ overlayType, overlays }) => {
          return (
            <OverlaySummary key={[overlayType, ...overlays].join(':')}>
              <OverlayTypeTitle>{overlayType}</OverlayTypeTitle>
              <OverlayList>
                {overlays.map((overlay) => (
                  <OverlayItem key={overlay}>{overlay}</OverlayItem>
                ))}
              </OverlayList>
            </OverlaySummary>
          );
        })}
      </OverlaySummaries>
      <MoreInformation dynamicContents={moreInformation} textColorVariant="textSecondary" />
    </StyledContentBrick>
  );
};
